'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'croissant';
var width = 512;
var height = 512;
var aliases = [129360];
var unicode = 'f7f6';
var svgPathData = 'M256 16c63.4 0 121 24.6 164 64.7l-121.4 121.4-65.7-185c7.6-.7 15.3-1.1 23.1-1.1zM431.3 92c31.5 33.7 53.4 76.5 61.4 124l-185.4 0 124-124zM19.2 216.7c16.7-101 96.4-180.8 197.4-197.4l86.1 242.7-40.9 40.9-242.7-86.1zM16 256c0-7.8 .4-15.5 1.1-23.1L202.1 298.5 80.7 420C40.6 377 16 319.4 16 256zM92 431.3l124-124 0 185.4c-47.5-8-90.3-29.9-124-61.4zM232 502l0-192.8 29.3 10.4 4.8 1.7 55.1-55.1-1.7-4.8-10.4-29.3 201.9 0-1.2-9C493.7 97.2 386.2 0 256 0 114.6 0 0 114.6 0 256 0 386.2 97.2 493.7 223 509.9l9 1.2 0-9.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCroissant = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;